import { render } from "./wnQueryCY.vue?vue&type=template&id=2e933390&scoped=true"
import script from "./wnQueryCY.vue?vue&type=script&lang=js"
export * from "./wnQueryCY.vue?vue&type=script&lang=js"

import "./wnQueryCY.vue?vue&type=style&index=0&id=2e933390&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2e933390"

export default script